import {maybeFetchWP} from '../../../../@shared/ts/maybe';
import {captureSentryException} from '../../../../@shared/ts/sentry';
import {FeatureFlag} from '../../../../@type/features';
import {Feature} from '../../reducers/environmentReducer';
import {getLocaleText} from '../../util/translation';
import {PeachPayOrder} from '../../reducers/peachPayOrderReducer';

/**
 * Validate the form data for the PeachPay checkout.
 */
async function validateCheckout(mode: 'billing' | 'billing_shipping'): Promise<boolean> {
	const validateURL = Feature.metadata<string>(FeatureFlag.EXPRESS_CHECKOUT, 'validate_url');
	if (!validateURL) {
		throw new Error('Validate URL is not set');
	}

	const formData = PeachPayOrder.billing.formData();

	if (mode === 'billing_shipping') {
		const shippingFormData = PeachPayOrder.shipping.formData();
		for (const [key, value] of shippingFormData.entries()) {
			formData.append(key, value);
		}

		// This might be empty if no additional fields are present but that is ok!
		const additionalFormData = PeachPayOrder.additional.formData();
		for (const [key, value] of additionalFormData.entries()) {
			formData.append(key, value);
		}
	}

	const {error, result} = await maybeFetchWP<{success: boolean; error_messages: string[]}>(validateURL, {
		method: 'POST',
		body: formData,
	});

	if (error || !result) {
		captureSentryException(error instanceof Error ? error : new Error('Unknown error while validating billing address'));
		return false;
	}

	if (!result.success) {
		if (result.error_messages) {
			// eslint-disable-next-line no-alert
			alert(result.error_messages.join('\n').replace(/(<([^>]+)>)/gi, ''));
		} else {
			// eslint-disable-next-line no-alert
			alert(getLocaleText('Something went wrong. Please try again.'));
		}

		return false;
	}

	return true;
}

export {
	validateCheckout,
};
